/* Misocozy: eigen JS, geladen met defer na misocozy-custom.css in layout/theme.liquid. Zie CUSTOMIZATIONS.md. */

/* Misocozy: tekst van de aankondigingsbalk als ticker als die niet past naast de knop. De knop blijft staan, de tekst komt uit de sectie-instellingen. */
(function () {
	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	function initTicker(bar) {
		var text = bar.querySelector('.misocozy-announcement-bar__text');
		if (!text || bar.hasAttribute('data-mz-ticker')) return;
		bar.setAttribute('data-mz-ticker', '');

		var ticker = document.createElement('div');
		var track = document.createElement('div');
		ticker.className = 'mz-ticker';
		track.className = 'mz-ticker__track';
		text.parentNode.insertBefore(ticker, text);
		ticker.appendChild(track);
		track.appendChild(text);

		var clone = text.cloneNode(true);
		clone.setAttribute('aria-hidden', 'true');
		Array.from(clone.querySelectorAll('a')).forEach(function (link) {
			link.setAttribute('tabindex', '-1');
		});

		function update() {
			bar.classList.remove('mz-ticker-on');
			if (clone.parentNode) clone.parentNode.removeChild(clone);
			bar.classList.add('mz-ticker-measure');
			var fits = text.getBoundingClientRect().width <= ticker.clientWidth;
			bar.classList.remove('mz-ticker-measure');
			if (fits || reducedMotion.matches) return;
			track.appendChild(clone);
			bar.classList.add('mz-ticker-on');
			var speed = parseFloat(getComputedStyle(bar).getPropertyValue('--mz-ticker-speed')) || 50;
			bar.style.setProperty('--mz-ticker-duration', text.getBoundingClientRect().width / speed + 's');
		}

		bar.addEventListener('touchstart', function () { bar.classList.add('mz-ticker-paused'); }, { passive: true });
		['touchend', 'touchcancel'].forEach(function (type) {
			bar.addEventListener(type, function () { bar.classList.remove('mz-ticker-paused'); }, { passive: true });
		});

		update();
		// Alleen op een andere breedte: update herstart de animatie.
		var lastWidth = bar.clientWidth;
		new ResizeObserver(function () {
			if (bar.clientWidth === lastWidth) return;
			lastWidth = bar.clientWidth;
			update();
		}).observe(bar);
		if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
		if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', update);
	}

	function initAll() {
		Array.from(document.querySelectorAll('.misocozy-announcement-bar')).forEach(initTicker);
	}

	initAll();
	document.addEventListener('shopify:section:load', initAll);
})();

/* Misocozy: mobiel menu als accordeon in plaats van slide-panelen. Klopt de markup van het theme niet (meer), dan doet dit niets en werkt het originele menu. */
(function () {
	var mobile = window.matchMedia('(max-width: 1000px)');
	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	var DURATION = 220; // gelijk aan de transition in misocozy-custom.css

	function getNav() {
		return document.querySelector('#nav');
	}

	function getMain(nav) {
		return nav && nav.querySelector(':scope > ul[data-type="main-nav"]');
	}

	function getParts(li) {
		var link = li.querySelector(':scope > a:not(.toggle)');
		var panel = li.querySelector(':scope > ul');
		if (!link || !panel || !li.querySelector(':scope > a.toggle')) return null;
		return { link: link, panel: panel };
	}

	// Alleen gewone linklijsten; promo-items (producten, banners) houden het gedrag van het theme.
	function getItems(main) {
		return Array.from(main.querySelectorAll('li')).filter(function (li) {
			var parts = getParts(li);
			return parts && !li.classList.contains('promo') && !li.closest('.show-all') && parts.panel.querySelector('li > a') && !parts.panel.querySelector('.l4cl, .l4ft');
		});
	}

	function addAllLink(li, parts) {
		var href = parts.link.getAttribute('href');
		if (!href || href === '#') return;
		var list = parts.panel.querySelector(':scope > li > ul') || parts.panel;
		var item = document.createElement('li');
		var allLink = document.createElement('a');
		item.className = 'mz-acc-all';
		allLink.href = href;
		allLink.textContent = 'Alle ' + parts.link.textContent.trim().replace(/\s+/g, ' ');
		item.appendChild(allLink);
		list.insertBefore(item, list.firstElementChild);
	}

	function isOpen(link) {
		return link.getAttribute('aria-expanded') === 'true';
	}

	function setOpen(li, open, instant) {
		var parts = getParts(li);
		if (isOpen(parts.link) === open && !instant) return;
		var panel = parts.panel;
		var from = li.classList.contains('mz-open') ? panel.getBoundingClientRect().height : 0;
		if (panel.mzFinish) panel.mzFinish();
		parts.link.setAttribute('aria-expanded', String(open));
		if (!open) Array.from(panel.querySelectorAll('li.mz-acc')).forEach(function (child) { setOpen(child, false, true); });

		li.classList.add('mz-open');
		if (instant || reducedMotion.matches) {
			li.classList.toggle('mz-open', open);
			return;
		}
		var to = open ? panel.scrollHeight : 0;
		var timer;
		function finish() {
			clearTimeout(timer);
			panel.removeEventListener('transitionend', onEnd);
			panel.mzFinish = null;
			panel.classList.remove('mz-acc-anim');
			panel.style.height = '';
			li.classList.toggle('mz-open', open);
		}
		function onEnd(e) {
			if (e.target === panel && e.propertyName === 'height') finish();
		}
		panel.mzFinish = finish;
		panel.classList.add('mz-acc-anim');
		panel.style.height = from + 'px';
		panel.getBoundingClientRect();
		panel.style.height = to + 'px';
		panel.addEventListener('transitionend', onEnd);
		timer = setTimeout(finish, DURATION + 80);
	}

	// Er staat er per niveau maar een open. Een open item erboven klapt direct dicht en de scrollpositie schuift mee, zodat de getikte regel onder de vinger blijft.
	// Kan dat niet (menu te kort om te scrollen), dan glijdt de regel naar zijn nieuwe plek.
	function toggle(li, nav) {
		var parts = getParts(li);
		if (isOpen(parts.link)) {
			setOpen(li, false);
			return;
		}
		var top = li.getBoundingClientRect().top;
		var scope = li.parentNode.closest('li.mz-acc') || getMain(nav);
		Array.from(scope.querySelectorAll('li.mz-acc')).forEach(function (other) {
			if (other === li || other.contains(li) || !isOpen(getParts(other).link)) return;
			var above = other.compareDocumentPosition(li) & Node.DOCUMENT_POSITION_FOLLOWING;
			setOpen(other, false, !!above);
		});
		nav.scrollTop += li.getBoundingClientRect().top - top;
		var shift = top - li.getBoundingClientRect().top;
		if (Math.abs(shift) > 1 && !reducedMotion.matches && li.parentNode.animate) {
			li.parentNode.animate([{ transform: 'translateY(' + shift + 'px)' }, { transform: 'none' }], { duration: DURATION, easing: 'ease' });
		}
		setOpen(li, true);
	}

	function activate(nav) {
		var main = getMain(nav);
		if (!main || nav.classList.contains('mz-accordion')) return;
		var items = getItems(main);
		if (!items.length) return;
		items.forEach(function (li) {
			var parts = getParts(li);
			li.classList.add('mz-acc');
			addAllLink(li, parts);
			parts.link.setAttribute('role', 'button');
			parts.link.setAttribute('aria-expanded', 'false');
		});
		nav.classList.add('mz-accordion');
	}

	function deactivate(nav) {
		var main = getMain(nav);
		if (!main || !nav.classList.contains('mz-accordion')) return;
		nav.classList.remove('mz-accordion');
		Array.from(main.querySelectorAll('li.mz-acc')).forEach(function (li) {
			var parts = getParts(li);
			setOpen(li, false, true);
			li.classList.remove('mz-acc');
			parts.link.removeAttribute('role');
			parts.link.removeAttribute('aria-expanded');
		});
		Array.from(main.querySelectorAll('.mz-acc-all')).forEach(function (item) { item.remove(); });
	}

	function sync() {
		var nav = getNav();
		if (!nav) return;
		if (mobile.matches) activate(nav);
		else deactivate(nav);
	}

	// De naam-link van een accordeon-item waar dit event op valt, anders null.
	function findTarget(e) {
		var nav = getNav();
		if (!nav || !nav.classList.contains('mz-accordion') || !e.target.closest) return null;
		var link = e.target.closest('a[aria-expanded]');
		var li = link && link.parentNode;
		if (!li || !li.classList.contains('mz-acc') || !getMain(nav).contains(li)) return null;
		return { li: li, nav: nav };
	}

	// Capture: het theme mag deze tik niet meer als navigatie of slide-paneel afhandelen.
	document.addEventListener('click', function (e) {
		var target = findTarget(e);
		if (!target) return;
		e.preventDefault();
		e.stopPropagation();
		toggle(target.li, target.nav);
	}, true);
	document.addEventListener('keydown', function (e) {
		if (e.key !== ' ') return;
		var target = findTarget(e);
		if (!target) return;
		e.preventDefault();
		toggle(target.li, target.nav);
	}, true);

	// Menu dicht: alles dicht, net als het theme na zijn eigen sluit-animatie. Menu open: het theme zet bij een tweede keer openen de tabindex niet terug.
	var wasOpen = false;
	new MutationObserver(function () {
		var open = document.documentElement.classList.contains('m2a');
		if (open === wasOpen) return;
		wasOpen = open;
		var nav = getNav();
		var main = getMain(nav);
		if (!main || !nav.classList.contains('mz-accordion')) return;
		if (open) {
			Array.from(main.querySelectorAll('a[tabindex="-1"]')).forEach(function (a) { a.removeAttribute('tabindex'); });
			return;
		}
		setTimeout(function () {
			if (wasOpen) return;
			Array.from(main.querySelectorAll('li.mz-acc')).forEach(function (li) { setOpen(li, false, true); });
		}, 400);
	}).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

	sync();
	if (mobile.addEventListener) mobile.addEventListener('change', sync);
	document.addEventListener('shopify:section:load', sync);
})();

/* Misocozy: subcategorie-rij op collectiepagina's. Verbergt de fade aan het einde van de rij en markeert de huidige collectie. Zonder dit script blijft de fade gewoon staan. */
(function () {
	function initNav(nav) {
		var list = nav.querySelector(':scope > .subcollections-nav__list');
		if (!list || nav.hasAttribute('data-mz-subnav')) return;
		nav.setAttribute('data-mz-subnav', '');

		Array.from(list.querySelectorAll('a.subcollections-nav__link')).forEach(function (link) {
			if (link.pathname === location.pathname) link.setAttribute('aria-current', 'page');
		});

		function update() {
			nav.classList.toggle('mz-subnav-end', list.scrollLeft + list.clientWidth >= list.scrollWidth - 1);
		}

		list.addEventListener('scroll', update, { passive: true });
		new ResizeObserver(update).observe(list);
		if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
		update();
	}

	function initAll() {
		Array.from(document.querySelectorAll('nav.subcollections-nav')).forEach(initNav);
	}

	initAll();
	document.addEventListener('shopify:section:load', initAll);
})();
